import { useCallback, useEffect, useRef, useState } from 'react';
import { usePusherBusinessChannel } from './PusherBusinessChannelProvider';
export function useBusinessChannelEventBinder(eventName, source) {
    const { getChannel, channelBusinessId } = usePusherBusinessChannel();
    const [listeners, setListeners] = useState([]);
    const boundCallbacksRef = useRef([]);
    const startListening = useCallback(function(callback) {
        let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        setListeners((prevListeners)=>[
                ...prevListeners,
                {
                    callback,
                    options,
                    isListening: false
                }
            ]);
    }, []);
    useEffect(()=>{
        if (channelBusinessId && listeners.some((l)=>!l.isListening)) {
            listeners.filter((l)=>!l.isListening).forEach((listener)=>{
                var _getChannel, _listener_options_onBind, _listener_options;
                (_getChannel = getChannel(source)) === null || _getChannel === void 0 ? void 0 : _getChannel.bind(eventName, listener.callback);
                boundCallbacksRef.current.push(listener.callback);
                (_listener_options_onBind = (_listener_options = listener.options).onBind) === null || _listener_options_onBind === void 0 ? void 0 : _listener_options_onBind.call(_listener_options);
                listener.isListening = true;
            });
        }
    }, [
        channelBusinessId,
        eventName,
        listeners,
        source
    ]);
    useEffect(()=>{
        return ()=>{
            const channel = getChannel(source);
            boundCallbacksRef.current.forEach((callback)=>channel === null || channel === void 0 ? void 0 : channel.unbind(eventName, callback));
            boundCallbacksRef.current = [];
        };
    }, [
        eventName,
        channelBusinessId,
        source
    ]);
    return {
        startListening,
        unbind: ()=>{
            const channel = getChannel(source);
            boundCallbacksRef.current.forEach((callback)=>channel === null || channel === void 0 ? void 0 : channel.unbind(eventName, callback));
            boundCallbacksRef.current = [];
        }
    };
}
